module.exports = __webpack_public_path__ + "img/redo.76f3e403.svg";